export default __webpack_public_path__ + "static/media/7-bottom.ae078ac4.png";